module.exports = __webpack_public_path__ + "static/media/winter secretary.ffc38d06.jpg";